import { Component, OnInit, HostListener } from '@angular/core';
import * as Parse from 'parse';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(
    private cookie: CookieService
  ) {
    // Initialize your Parse App Keys
    // PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY

  }
  title = 'Viora';
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    localStorage.clear();
  }

  ngOnInit(): void {
    this.checkLogin();
  }

  ngOnDestroy() {
    localStorage.clear();
  }

  checkLogin(): boolean {
    if (this.cookie.get('sessionToken')) {
      if (this.cookie.get('isRegistering')) {
        if (!this.cookie.get('isFinishedLogin')) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  }

}
